<template>
    <div class="logoutCon">
        <p>是否要退出登录吗？</p>
        <div>
            <div @click="logoutBtn">确认</div>
            <div @click="goAudienceInfo">取消</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    mounted() {

    },
    methods: {
        logoutBtn() {
            let that = this;
            that.allApi.logout().then((resource) => {
                if( resource.data.code == 200 ) {
                    sessionStorage.setItem("online", false);

                    that.$store.commit("setOnline", false);

                    sessionStorage.setItem("admin", false);

                    that.$store.commit("setAdmin", false);

                    that.$router.push("/");
                }
            })
        },
        goAudienceInfo() {
            let that = this;
            that.$router.push("audienceInfo");
        }
    }
}
</script>
<style lang="scss" scoped>
    .logoutCon{
        padding-top: 100px;
        >p{
            text-align: center;
            margin-bottom: 90px;
            text-align: center;
            @include dominant_color(#1c1c1c);
            font-size: 24px;
        }
        >div{
            width: 260px;
            margin: 0 auto;
            overflow: hidden;
            >div{
                float: left;
                background:linear-gradient(0deg,rgba(26,167,224,1) 0%,rgba(56,189,255,1) 48%,rgba(26,167,224,1) 100%);
                height: 40px;
                border-radius: 10px;
                width: 86px;
                color: #fff;
                text-align: center;
                line-height: 40px;
                font-size: 18px;
                cursor: pointer;
                &:last-child{
                    float: right;
                    background: #999999;
                }
            }
        }
    }
</style>
